"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripeSubscription = exports.Payment = exports.PaymentOffering = exports.UpdateSubscriptionDto = exports.SubscriptionCancelDto = exports.RefundDto = exports.CreateSubscriptionDto = exports.UpdateCardDto = exports.PreviewSubscriptionUpdateDto = exports.PreviewItemDto = exports.CreatePaymentIntentDto = exports.CreatePaymentIntentResponseDto = exports.StripeSubscriptionResponse = exports.PaymentResponseModel = exports.MoneyModel = exports.StripeSubscriptionStatus = void 0;
var StripeSubscriptionStatus;
(function (StripeSubscriptionStatus) {
    StripeSubscriptionStatus["Active"] = "active";
    StripeSubscriptionStatus["Trial"] = "trial";
    StripeSubscriptionStatus["PastDue"] = "past_due";
    StripeSubscriptionStatus["Deleted"] = "deleted";
    StripeSubscriptionStatus["Cancelled"] = "cancelled";
    StripeSubscriptionStatus["Unknown"] = "unknown";
})(StripeSubscriptionStatus = exports.StripeSubscriptionStatus || (exports.StripeSubscriptionStatus = {}));
class MoneyModel {
}
exports.MoneyModel = MoneyModel;
class PaymentResponseModel {
}
exports.PaymentResponseModel = PaymentResponseModel;
class StripeSubscriptionResponse extends PaymentResponseModel {
}
exports.StripeSubscriptionResponse = StripeSubscriptionResponse;
class CreatePaymentIntentResponseDto {
}
exports.CreatePaymentIntentResponseDto = CreatePaymentIntentResponseDto;
class CreatePaymentIntentDto {
}
exports.CreatePaymentIntentDto = CreatePaymentIntentDto;
class PreviewItemDto {
}
exports.PreviewItemDto = PreviewItemDto;
class PreviewSubscriptionUpdateDto {
}
exports.PreviewSubscriptionUpdateDto = PreviewSubscriptionUpdateDto;
class UpdateCardDto {
}
exports.UpdateCardDto = UpdateCardDto;
class CreateSubscriptionDto {
    constructor() {
        this.extraMetadata = {};
    }
}
exports.CreateSubscriptionDto = CreateSubscriptionDto;
class RefundDto {
}
exports.RefundDto = RefundDto;
class SubscriptionCancelDto {
}
exports.SubscriptionCancelDto = SubscriptionCancelDto;
class UpdateSubscriptionDto {
}
exports.UpdateSubscriptionDto = UpdateSubscriptionDto;
class PaymentOffering {
}
exports.PaymentOffering = PaymentOffering;
class Payment {
}
exports.Payment = Payment;
class StripeSubscription extends Payment {
}
exports.StripeSubscription = StripeSubscription;
